/**
 * Human-readable labels for PPE violations.
 *
 * Two naming schemes reach the UI and both must be handled:
 *   - alert subTypes            e.g. MISSING_VEST      (alerts / event feed)
 *   - engine violation classes  e.g. head_nohelmet     (live detection stream)
 *
 * Without a mapping the live path renders raw internal names ("head_nohelmet"),
 * which is meaningless to an operator. Shared here so the side panel and the
 * canvas overlay can't drift apart.
 */
export const VIOLATION_LABELS = {
  // alert subTypes
  MISSING_VEST: 'Missing Vest',
  MISSING_HELMET: 'Missing Helmet',
  MISSING_HARDHAT: 'Missing Helmet',
  MISSING_GLOVES: 'Missing Gloves',
  MISSING_GOGGLES: 'Missing Goggles',
  MISSING_GLASSES: 'Missing Glasses',
  MISSING_BOOTS: 'Missing Boots',
  MISSING_MASK: 'Missing Mask',
  MISSING_HARNESS: 'Missing Harness',
  MISSING_EAR_PROTECTION: 'Missing Ear Protection',
  IMPROPER_FOOTWEAR: 'Improper Footwear',
  FALL_DETECTED: 'Fall Detected',

  // engine-internal violation classes
  head_nohelmet: 'No Helmet',
  no_vest: 'No Vest',
  hand_noglove: 'No Gloves',
  face_nomask: 'No Mask',
  No_Glasses: 'No Glasses',
  'No_Ear-Protection': 'No Ear Protection',
  no_harness: 'No Harness',
  Barefoots: 'No Boots',
  Sandals: 'Improper Footwear',
};

/**
 * Label for a violation key. Falls back to a de-underscored, title-cased form so
 * an unmapped key still reads reasonably instead of leaking snake_case.
 */
export const violationLabel = (key) => {
  if (!key) return '';
  if (VIOLATION_LABELS[key]) return VIOLATION_LABELS[key];
  return String(key)
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
